import axios from "axios"
import qs from "qs"
import { LEGACY_API_BASE_URL } from "../config"
interface LoginResponse {
  id: string
  name: string
  loginId: string
  cardNumber: string
}

export const legacyLogin = async (
  id: string,
  password: string
): Promise<LoginResponse> => {
  const url = `${LEGACY_API_BASE_URL}/gns/Android_Login`
  const data = qs.stringify({
    login_account: id,
    webpwd: password,
  })
  const response = await axios.post(url, data, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
  if (response.status !== 200) {
    throw new Error("Login failed")
  }
  const parser = new DOMParser()
  const xmlDoc = parser.parseFromString(response.data, "text/xml")
  const root = xmlDoc.getElementsByTagName("Root")[0]
  const result = root.getElementsByTagName("Result")[0]
  const row = result?.getElementsByTagName("Row")[0]
  if (!row) {
    throw new Error("Authentication failed")
  }
  return {
    id: row.getElementsByTagName("member_c")[0]?.textContent || "",
    name: row.getElementsByTagName("siyosyasei_kanji")[0]?.textContent || "",
    loginId: row.getElementsByTagName("login_account")[0]?.textContent || "",
    cardNumber: row.getElementsByTagName("memcard_no")[0]?.textContent || "",
  }
}
